import { call,put, select } from "redux-saga/effects";
import { selectCallSessions, setCallSessions } from "../../../state/callSessions/callSessionsSlice";

export function* updateCallSessionSaga({ payload }) {
    const sessions = yield select(selectCallSessions);
    yield put(setCallSessions([...sessions]));
  }
